


// bucketMs is the width of one condensed sample for the table this timeframe
// reads. It MUST match the producing step's interval in the condenser
// (trimmer/src/_condensor/params.js). secs reads the raw realtime table
// (edge data) -> bucketMs 0 keeps the renderer in edge mode for it.
export const timeframes = {
    secs:   { tableKey: 'table0_secs',   hours: 5/60,     bucketMs: 0,        label: 'secs'   },
    mins:   { tableKey: 'table1_mins',   hours: 2,        bucketMs: 5000,     label: 'mins'   },
    hours:  { tableKey: 'table2_hours',  hours: 12,       bucketMs: 30000,    label: 'hours'  },
    days:   { tableKey: 'table3_days',   hours: 72,       bucketMs: 120000,   label: 'days'   },
    weeks:  { tableKey: 'table4_weeks',  hours: 504,      bucketMs: 600000,   label: 'weeks'  },
    months: { tableKey: 'table5_months', hours: 2184,     bucketMs: 3600000,  label: 'months' },
    years:  { tableKey: 'table6_years',  hours: 17472,    bucketMs: 21600000, label: 'years'  },
};

export const secondsTimeframes = {
    secs:   true,
    mins:   false,
    hours:  false,
    days:   false,
    weeks:  false,
    months: false,
    years:  false,
};

export const defaultGraphParams = {
    xScaleHeight:         40,
    yScaleWidth:          39,
    verticalPadding:      0.1,
    legend_width:         20,
    legend_height:        5,
    motionUpdateInterval: 100,
    noDataText:           '[ currently no data ]',
    noDataColor:          '#999',
    noDataFontPx:         14,
};